import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import {
  BackgroundColors,
  TextColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';
import { canHover } from '@picsart/design-system/styleUtils/hoverTouch';

const useStyles = createUseStyles(
  {
    '@keyframes slideInUp': {
      from: {
        opacity: 0,
        transform: 'translateY(20px)',
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
    footer: {
      padding: Spacings.s12,
      backgroundColor: BackgroundColors.base,
      // No DS easing match for cubic-bezier(0.16, 1, 0.3, 1) — bespoke "out-expo"-style curve
      animation: '$slideInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.2s both',
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        padding: Spacings.s8,
      },
    },
    termsText: {
      fontSize: FontSizes.t3,
      color: TextColors.tint1,
      textAlign: 'center',
      marginTop: Spacings.s8,
    },
    termsLink: {
      color: PrimaryColors.base.default,
      textDecoration: 'none',
      [canHover]: {
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
    // Credits loading spinner (inline in button)
    creditsSpinner: {
      display: 'inline-block',
      marginLeft: Spacings.s4,
      verticalAlign: 'middle',
    },
    generateButton: {},
    sparklesIcon: {
      marginLeft: Spacings.s6,
      marginRight: Spacings.s2,
      verticalAlign: 'middle',
      width: 20,
      height: 20,
    },
  },
  { name: 'create-footer' }
);

export default useStyles;
